import PropTypes from 'prop-types';
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { checkValIsEmpty } from '../../utils/common';
const formInput = ({
  id,
  name,
  type,
  placeholder,
  className,
  value,
  info,
  error,
  readOnly,
  label,
  maxlength,
  defaultValue,
  islabelInCol,
  noLabel,
  rows,
  icon,
  strengthBar,
  prefixIcon,
  ...props
}) => {
  return (
    <Form.Group className={`${className}`}>
      
      {!noLabel && <Form.Label className={'float-left mr-2 mb-1'}  htmlFor={id}>{label}</Form.Label>}
      {rows ? <textarea 
        rows={rows}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        onChange={props.onChange}
        value={value}
        defaultValue={defaultValue}
        maxLength={maxlength}
        readOnly={readOnly}
        className='form-control has-prefix'
        style={
          error ? { border: '1px solid red',borderRadius: 7} : {}
        }
        {...props}
      /> : 
        <InputGroup style={
          error && icon ? { border: '1px solid red', borderRadius: 4 } : !error &&
          icon ? {border: '1px solid #ced4da', borderRadius: 4} : {}
        }>
          {
            prefixIcon
          }
          <Form.Control
            id={id}
            name={name}
            type={type}
            placeholder={placeholder}
            onChange={props.onChange}
            value={value}
            defaultValue={defaultValue}
            maxLength={maxlength}
            readOnly={readOnly}
            autoComplete='off'
            className={`
              has-prefix ${getClassName(props)} 
              ${error ? 'error-box-shadow' : ''} ${name === 'search' ? 'pe-5': ''}
            `}
            style={
              error &&
              !icon ? { border: '1px solid red',borderRadius: 4 } : icon ? {border: 'none'} : {}
            }
            {...props}
          />
          {
            icon
          }
          {
            (error &&  islabelInCol) && <div>{error}</div>
          }
        </InputGroup>
      }
      {(error &&  !islabelInCol) && <div>{error}</div>}
      <small className="form-text text-muted ml-1">{info}</small>
      {
        !checkValIsEmpty(strengthBar) && strengthBar
      }
    </Form.Group>
  );
};
formInput.defaultProps = {
  type: 'text',
  className: ''
};
formInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'number', 'password', 'email']),
  className: PropTypes.string,
  value: PropTypes.any,
  islabelInCol:PropTypes.bool,
  isFeedbackForm:PropTypes.bool
};
export default formInput;

const getClassName = props => {
  if (props.isSignUp) return 'py-2 px-3';
  if (props.isAdjustmentWindow) return 'p-2';
  if (props.createProduct) return 'py-2';
  if (props.isOrderItemEdit) return 'py-0 px-2';
  if (props.isFeedbackForm) return 'py-2 s8-name';
  return 'p-3';
};
